import { API_ENDPOINTS } from "./apiEndpoints";

export interface Stop {
  PlaceName: string;
  OgtType: string;
  Ll: [number, number];
  Id: number;
}

export async function findPoints(
  query: string,
  signal?: AbortSignal
): Promise<Stop[]> {
  const trimmedQuery = query.trim();

  if (trimmedQuery.length < 2) {
    return [];
  }

  const searchParams = new URLSearchParams({
    q: trimmedQuery,
  });

  const response = await fetch(
    `${API_ENDPOINTS.findPoints}?${searchParams.toString()}`,
    { signal }
  );

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(
      `Kunde inte söka efter hållplatser. API:t svarade med ${response.status}.`
    );
  }

  return Array.isArray(data) ? data : [];
}
